import type { UserListItem } from '@/domain/users/entities/user.entity'

export type UserSortField = keyof UserListItem

export interface UsersDeleteDialogState {
  isOpen: boolean
  userId: string | null
  userName: string
}

export const initialDeleteDialogState: UsersDeleteDialogState = {
  isOpen: false,
  userId: null,
  userName: '',
}
